// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { library, IconPrefix, IconDefinition, IconName } from '@fortawesome/fontawesome-svg-core';
import {
    faHorizontalRule,
    faList,
    faText,
    faCertificate,
    faCoffee,
    faUser,
    faSpellCheck,
    faLockKeyholeOpen,
    faNetworkWired,
    faServer,
    faLockA,
    faPenSquare,
    faLandmark,
    faCopyright,
    faFilter,
    faFileImage,
    faFileCsv,
    faFileImport,
    faFileExport,
    faFile,
    faPenLine,
    faLockKeyhole,
    faCopy,
    faArrowLeft,
    faArrowRight,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faBell,
    faIdBadge,
    faChartColumn,
    faClone,
    faFillDrip,
    faCalculator,
    faSliders,
    faFire,
    faFlag,
    faChartLine,
    faChartPie,
    faChartRadar,
    faTableRows,
    faGauge,
    faChartMixed,
    faMagnifyingGlass,
    faFileMagnifyingGlass,
    faClipboardListCheck,
    faIdCard,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faPenToSquare,
    faObjectGroup,
    faPlus,
    faCirclePlus,
    faSquarePlus,
    faChevronDown,
    faCircleChevronDown,
    faCircleCheck,
    faClock,
    faFingerprint,
    faTrash,
    faInbox,
    faKey,
    faLink,
    faLinkSimple,
    faPaperclip,
    faCircleQuestion,
    faBook,
    faRotateRight,
    faShareNodes,
    faRotate,
    faTag,
    faTags,
    faCircleChevronUp,
    faTriangleExclamation,
    faCommentDots,
    faEllipsis,
    faCheck,
    faCalendar,
    faCalendarPlus,
    faCalendarPen,
    faCircleXmark,
    faTableCells,
    faChessKnight,
    faCalendarExclamation,
    faTimelineArrow,
    faListTimeline,
    faObjectsAlignCenterHorizontal,
    faXmark,
    faBriefcase,
    faArrowDownLeftAndArrowUpRightToCenter,
    faFloppyDisk,
    faFloppyDiskCircleArrowRight,
    faFileLines,
    faGear,
    faThumbTack,
    faMemoCircleCheck,
    faEye,
    faEyeSlash,
    faCompass,
    faFilePlus,
    faFileCode,
    faFileAward,
    faFunction,
    faCirclePlay,
    faBriefcaseBlank,
    faStar,
    faLinkSimpleSlash,
    faCircleBolt,
    faBoltLightning,
    faArrowUpRightFromSquare,
    faStarExclamation,
    faUserPlus,
    faFolder,
    faFileCirclePlus,
    faUserShield,
    faAsterisk,
} from '@fortawesome/pro-regular-svg-icons';

import {
    faTriangle,
    faChevronLeft,
    faChevronRight,
    faLockKeyhole as faLockKeyholeSolid,
    faFlag as faFlagSolid,
    faCaretDown,
    faCaretUp,
    faCircleQuestion as faCircleQuestionSolid,
    faQuoteRight,
    faThumbTack as faThumbTackSolid,
    faStar as faStarSolid,
} from '@fortawesome/pro-solid-svg-icons';

import {
    faFilter as faFilterDuotone,
    faUpload,
    faCopy as faCopyDuotone,
    faDownload,
    faChartArea,
    faFlag as faFlagDuotone,
    faSirenOn,
    faListCheck,
    faBriefcase as faBriefcaseDuo,
    faSlidersUp,
    faScrewdriverWrench,
    faRightFromBracket,
    faChessKnight as faChessKnightDuo,
    faSiren,
    faUsers,
    faFileZipper,
    faCartFlatbedSuitcase,
    faBoxArchive,
    faFolderGear,
    faGears,
    faStar as faStarDuotone,
} from '@fortawesome/pro-duotone-svg-icons';

import { faAndroid, faApple, faMicrosoft } from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

import {
    ApartmentOutlined,
    ApiOutlined,
    CheckCircleTwoTone,
    CloseCircleTwoTone,
    CopyTwoTone,
    DeleteTwoTone,
    EyeTwoTone,
    InfoCircleOutlined,
    LoadingOutlined,
    MenuOutlined,
    MinusCircleOutlined,
    MinusSquareOutlined,
    PlusCircleTwoTone,
    PushpinOutlined,
    SaveTwoTone,
    SettingTwoTone,
    SnippetsOutlined,
    SortAscendingOutlined,
    ThunderboltOutlined,
    VerticalAlignBottomOutlined,
    WarningTwoTone,
} from '@ant-design/icons';

import { faEquals } from '@fortawesome/pro-light-svg-icons/faEquals';

export const installIcons = (): void => {
    const listIcon = [
        faTriangle,
        faHorizontalRule,
        faList,
        faText,
        faCertificate,
        faQuoteRight,
        faClone,
        faCoffee,
        faUser,
        faSpellCheck,
        faLockKeyhole,
        faServer,
        faLockKeyholeSolid,
        faCopyright,
        faLockKeyholeOpen,
        faNetworkWired,
        faLandmark,
        faPenSquare,
        faLockA,
        faChevronLeft,
        faChevronRight,
        faFilter,
        faFilterDuotone,
        faBell,
        faUpload,
        faFileImport,
        faFileExport,
        faFileImage,
        faFileCsv,
        faFile,
        faFolder,
        faPenLine,
        faCopy,
        faCopyDuotone,
        faArrowLeft,
        faArrowRight,
        faArrowUpRightAndArrowDownLeftFromCenter,
        faArrowDownLeftAndArrowUpRightToCenter,
        faChartColumn,
        faChartArea,
        faChartLine,
        faChartPie,
        faChartRadar,
        faChartMixed,
        faGauge,
        faIdBadge,
        faFillDrip,
        faCalculator,
        faDownload,
        faFileCirclePlus,
        faSliders,
        faFire,
        faCircleXmark,
        faFlag,
        faFlagSolid,
        faFlagDuotone,
        faFunction,
        faTableRows,
        faSirenOn,
        faStarExclamation,
        faListCheck,
        faMagnifyingGlass,
        faMagnifyingGlassMinus,
        faMagnifyingGlassPlus,
        faFileMagnifyingGlass,
        faClipboardListCheck,
        faBriefcase,
        faSlidersUp,
        faSiren,
        faScrewdriverWrench,
        faRightFromBracket,
        faIdCard,
        faPenToSquare,
        faObjectGroup,
        faPlus,
        faCirclePlus,
        faSquarePlus,
        faChevronDown,
        faCircleChevronDown,
        faCircleChevronUp,
        faCaretDown,
        faCaretUp,
        faCircleCheck,
        faClock,
        faFingerprint,
        faTrash,
        faInbox,
        faKey,
        faLink,
        faLinkSimple,
        faPaperclip,
        faCircleQuestion,
        faCircleQuestionSolid,
        faBook,
        faRotateRight,
        faShareNodes,
        faRotate,
        faTag,
        faTags,
        faTriangleExclamation,
        faCommentDots,
        faEllipsis,
        faCheck,
        faCalendar,
        faCalendarPlus,
        faCalendarPen,
        faTableCells,
        faChessKnight,
        faChessKnightDuo,
        faCalendarExclamation,
        faTimelineArrow,
        faListTimeline,
        faObjectsAlignCenterHorizontal,
        faXmark,
        faBriefcaseDuo,
        faUsers,
        faApple,
        faAndroid,
        faMicrosoft,
        faFloppyDisk,
        faFloppyDiskCircleArrowRight,
        faFileLines,
        faGear,
        faThumbTack,
        faThumbTackSolid,
        faMemoCircleCheck,
        faEye,
        faEyeSlash,
        faCompass,
        faFilePlus,
        faFileCode,
        faFileAward,
        faCirclePlay,
        faFileZipper,
        faBriefcaseBlank,
        faCartFlatbedSuitcase,
        faBoxArchive,
        faFolderGear,
        faGears,
        faStar,
        faStarDuotone,
        faStarSolid,
        faLinkSimple,
        faLinkSimpleSlash,
        faCircleBolt,
        faBoltLightning,
        faArrowUpRightFromSquare,
        faUserPlus,
        faEquals,
        faUserShield,
        faAsterisk,
    ] as IconDefinition[];
    library.add(...listIcon);
};

type FontAppIconProps = Omit<FontAwesomeIconProps, 'icon'>;

// TODO check syntax
const faIcon = (style: IconPrefix, cls: IconName): any => {
    return (props: FontAppIconProps): ReactElement => (
        <span className="anticon cursor-pointer">
            <FontAwesomeIcon {...props} icon={[style, cls]} />
        </span>
    );
};

export const ICONS = {
    MatchWord: faIcon('fal', 'equals'),
    Folder: faIcon('far', 'folder'),
    ApartmentOutlined,
    ApiOutlined,
    MixedChartOutlined: faIcon('far', 'chart-mixed'),
    AreaChartOutlined: faIcon('fad', 'chart-area'),
    ArrowLeftOutlined: faIcon('far', 'arrow-left'),
    ArrowRightOutlined: faIcon('far', 'arrow-right'),
    ArrowsAltOutlined: faIcon('far', 'arrow-up-right-and-arrow-down-left-from-center'),
    Asterisk: faIcon('far', 'asterisk'),
    BarChartOutlined: faIcon('far', 'chart-column'),
    BellOutlined: faIcon('far', 'bell'),
    GaugeChartOutlined: faIcon('far', 'gauge'),
    BgColorsOutlined: faIcon('far', 'fill-drip'),
    CalculatorOutlined: faIcon('far', 'calculator'),
    CaretDownOutlined: faIcon('fas', 'caret-down'),
    CheckCircleOutlined: faIcon('far', 'circle-check'),
    CheckCircleTwoTone,
    ClockCircleOutlined: faIcon('far', 'clock'),
    CloseCircleTwoTone,
    ControlOutlined: faIcon('far', 'sliders'),
    CopyrightIcon: faIcon('far', 'copyright'),
    CenterIcon: faIcon('far', 'objects-align-center-horizontal'),
    CopyOutlined: faIcon('far', 'copy'),
    CloneIcon: faIcon('far', 'clone'),
    CopyTwoTone,
    DeleteTwoTone,
    DividerOutlined: faIcon('far', 'horizontal-rule'),
    DownCircleOutlined: faIcon('far', 'circle-chevron-down'),
    DownloadOutlined: faIcon('fad', 'download'),
    DownOutlined: faIcon('far', 'chevron-down'),
    ExportOutlined: faIcon('far', 'file-export'),
    ExportFileIcon: faIcon('far', 'floppy-disk-circle-arrow-right'),
    EyeTwoTone,
    FileOutlined: faIcon('far', 'file'),
    FileImageOutlined: faIcon('far', 'file-image'),
    FileCSVOutlined: faIcon('far', 'file-csv'),
    FileSearchOutlined: faIcon('far', 'file-magnifying-glass'),
    FilterOutlined: faIcon('far', 'filter'),
    FilterTwoTone: faIcon('fad', 'filter'),
    FireOutlined: faIcon('far', 'fire'),
    FlagFilled: faIcon('fad', 'flag'),
    FlagOutlined: faIcon('far', 'flag'),
    FormOutlined: faIcon('far', 'pen-to-square'),
    GroupOutlined: faIcon('far', 'object-group'),
    ImportOutlined: faIcon('far', 'file-import'),
    InboxOutlined: faIcon('far', 'inbox'),
    InfoCircleOutlined,
    InsertRowAboveOutlined: faIcon('far', 'table-rows'),
    KeyOutlined: faIcon('far', 'key'),
    LeftOutlined: faIcon('fas', 'chevron-left'),
    LineChartOutlined: faIcon('far', 'chart-line'),
    Link: faIcon('far', 'link'),
    LinkOutlined: faIcon('far', 'link-simple'),
    ExternalLink: faIcon('far', 'arrow-up-right-from-square'),
    ListOutlined: faIcon('far', 'list'),
    LockOutlined: faIcon('far', 'lock-a'),
    LogoutOutlined: faIcon('fad', 'right-from-bracket'),
    MenuOutlined,
    MinusCircleOutlined,
    MinusSquareOutlined,
    NetworkWiredOutlined: faIcon('far', 'network-wired'),
    PaperClipOutlined: faIcon('far', 'paperclip'),
    PieChartOutlined: faIcon('far', 'chart-pie'),
    PlusCircleOutlined: faIcon('far', 'circle-plus'),
    PlusCircleTwoTone,
    PlusSquareOutlined: faIcon('far', 'square-plus'),
    QuestionCircleFilled: faIcon('fas', 'circle-question'),
    QuestionCircleOutlined: faIcon('far', 'circle-question'),
    QuoteRight: faIcon('fas', 'quote-right'),
    RadarChartOutlined: faIcon('far', 'chart-radar'),
    ReadOutlined: faIcon('far', 'book'),
    ReloadOutlined: faIcon('far', 'rotate-right'),
    RightOutlined: faIcon('fas', 'chevron-right'),
    SaveOutlined: faIcon('far', 'floppy-disk'),
    SaveTwoTone,
    SettingTwoTone,
    ServerOutlined: faIcon('far', 'server'),
    ShareAltOutlined: faIcon('far', 'share-nodes'),
    SnippetsOutlined,
    SortAscendingOutlined,
    StarExclamation: faIcon('far', 'star-exclamation'),
    SyncOutlined: faIcon('far', 'rotate'),
    TableOutlined: faIcon('far', 'table-cells'),
    TagOutlined: faIcon('far', 'tag'),
    TagsOutlined: faIcon('far', 'tags'),
    TextOutlined: faIcon('far', 'text'),
    ThunderboltOutlined,
    TriangleOutlined: faIcon('fas', 'triangle'),
    UpCircleOutlined: faIcon('far', 'circle-chevron-up'),
    UploadOutlined: faIcon('fad', 'upload'),
    UserPlus: faIcon('far', 'user-plus'),
    UserMFA: faIcon('far', 'user-shield'),
    VerticalAlignBottomOutlined,
    WarningOutlined: faIcon('far', 'triangle-exclamation'),
    WarningTwoTone,
    CommentOutlined: faIcon('far', 'comment-dots'),
    ZoomInOutlined: faIcon('far', 'magnifying-glass-plus'),
    ZoomOutOutlined: faIcon('far', 'magnifying-glass-minus'),

    // Entities
    CustomFieldIcon: faIcon('far', 'pen-to-square'),
    CaseIcon: faIcon('fad', 'briefcase'),
    EmptyCaseIcon: faIcon('far', 'briefcase-blank'),
    CaseTemplateIcon: faIcon('fad', 'cart-flatbed-suitcase'),
    ReportTemplateIcon: faIcon('far', 'file-circle-plus'),
    CertificateAuthorityIcon: faIcon('far', 'file-certificate'),
    CaseIconOutlined: faIcon('far', 'briefcase'),
    TaskIcon: faIcon('fad', 'list-check'),
    TaskLogIcon: faIcon('far', 'clipboard-list-check'),
    ObservableIcon: faIcon('far', 'fingerprint'),
    AlertIcon: faIcon('fad', 'siren-on'),
    JobIcon: faIcon('far', 'file-lines'),
    AuditIcon: faIcon('far', 'memo-circle-check'),
    OrganisationIcon: faIcon('far', 'landmark'),
    TTPIcon: faIcon('fad', 'chess-knight'),
    TimelineEventIcon: faIcon('far', 'calendar-exclamation'),
    TimelineGraphIcon: faIcon('far', 'timeline-arrow'),
    TimelineListIcon: faIcon('far', 'list-timeline'),
    EntityIcon: faIcon('fad', 'sliders-up'),
    PlatformIcon: faIcon('fad', 'screwdriver-wrench'),
    DashboardIcon: faIcon('fad', 'chart-area'),
    FunctionIcon: faIcon('far', 'function'),
    UserIcon: faIcon('far', 'user'),
    LicenseIcon: faIcon('far', 'id-badge'),
    UsersIcon: faIcon('fad', 'users'),
    UserProfileIcon: faIcon('far', 'id-card'),
    ActionIcon: faIcon('far', 'ellipsis'),
    PlusIcon: faIcon('far', 'plus'),
    CheckIcon: faIcon('far', 'check'),
    CloseIcon: faIcon('far', 'xmark'),
    CloseCircleIcon: faIcon('far', 'circle-xmark'),
    DateIcon: faIcon('far', 'calendar'),
    CreationDateIcon: faIcon('far', 'calendar-plus'),
    UpdateDateIcon: faIcon('far', 'calendar-pen'),
    LoadingIcon: LoadingOutlined,
    DeleteIcon: faIcon('far', 'trash'),
    SettingIcon: faIcon('far', 'gear'),
    StarIcon: faIcon('far', 'star'),
    PinIcon: faIcon('far', 'thumb-tack'),
    UnpinIcon: faIcon('fas', 'thumb-tack'),
    PushpinFilled: faIcon('fas', 'thumb-tack'),
    SirenIcon: faIcon('fad', 'siren'),
    ArchiveIcon: faIcon('fad', 'file-zipper'),
    BoxArchiveIcon: faIcon('fad', 'box-archive'),

    AppleIcon: faIcon('fab', 'apple'),
    AndroidIcon: faIcon('fab', 'android'),
    WindowsIcon: faIcon('fab', 'microsoft'),

    EditIcon: faIcon('far', 'pen-line'),
    EyeIcon: faIcon('far', 'eye'),
    EyeInvisibleIcon: faIcon('far', 'eye-slash'),
    CreateIcon: faIcon('far', 'file-plus'),
    MergeIcon: faIcon('far', 'arrow-down-left-and-arrow-up-right-to-center'),
    RespondersIcon: faIcon('fad', 'folder-gear'),
    RunResponderIcon: faIcon('far', 'gear'),
    // RespondersIcon: faIcon('fad', 'gears'),

    SourceIcon: faIcon('far', 'compass'),
    ReferenceIcon: faIcon('far', 'file-code'),
    TypeIcon: faIcon('far', 'file-award'),

    SearchIcon: faIcon('far', 'magnifying-glass'),
    AttributesIcon: PushpinOutlined,
    StartIcon: faIcon('far', 'circle-play'),

    LockFilled: faIcon('fas', 'lock-keyhole'),
    LockIcon: faIcon('far', 'lock-keyhole'),
    UnlockIcon: faIcon('far', 'lock-keyhole-open'),

    // IocOutline: faIcon('far', 'star'),
    IocIcon: faIcon('far', 'fingerprint'),
    IocOutline: faIcon('far', 'star'),
    IocSolid: faIcon('fas', 'star'),

    IgnoreSimilarityTrue: faIcon('far', 'link-simple-slash'),
    IgnoreSimilarityFalse: faIcon('far', 'link-simple'),

    // SightedIcon: faIcon('far', 'circle-bolt'),
    SightedIcon: faIcon('far', 'bolt-lightning'),

    ExternalLinkIcon: faIcon('far', 'arrow-up-right-from-square'),
};
